import { Link } from "react-router-dom";
import { FolderKanban, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/AuthContext";
import { usePayment } from "../lib/PaymentContext";
import { publicRoutes } from "../lib/routes";

export default function Header() {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();
  const { boostBalance, loading, billingHidden } = usePayment();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Failed to sign out:", error);
    }
  };

  return (
    <nav className="bg-card shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-6">
            <Link to="/" className="text-xl font-bold text-foreground">
              NaraHub
            </Link>
            <Link
              to={publicRoutes.home}
              className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            >
              <FolderKanban className="h-4 w-4" />
              <span>{t('nav.projects')}</span>
            </Link>
          </div>
          <div className="flex items-center space-x-6">
            {!billingHidden && (
              <Link
                to="/billing"
                className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
              >
                <Zap className="h-4 w-4 text-yellow-500" />
                <span className={`font-medium ${loading ? "opacity-50" : ""}`}>
                  {boostBalance.toLocaleString()}
                </span>
              </Link>
            )}
            <span className="text-sm text-muted-foreground">
              {user?.email ?? "dev@local"}
            </span>
            <button
              onClick={handleSignOut}
              className="text-sm text-muted-foreground hover:text-foreground"
            >
              {t('auth.signOut')}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
